export const Colors = Object.freeze({
    RED: '--red-500',
    BLUE: '--blue-500',
    GREEN: '--green-500',
    YELLOW: '--yellow-500',
    CYAN: '--cyan-500',
    PINK: '--pink-500',
    INDIGO: '--indigo-500',
    TEAL: '--teal-500',
    ORANGE: '--orange-500',
    BLUEGRAY: '--bluegray-500',
    PURPLE: '--purple-500',
});

export const getAllColors = () => {
    return [
        { name: 'Red', value: Colors.RED },
        { name: 'Blue', value: Colors.BLUE },
        { name: 'Green', value: Colors.GREEN },
        { name: 'Yellow', value: Colors.YELLOW },
        { name: 'Cyan', value: Colors.CYAN },
        { name: 'Pink', value: Colors.PINK },
        { name: 'Indigo', value: Colors.INDIGO },
        { name: 'Teal', value: Colors.TEAL },
        { name: 'Orange', value: Colors.ORANGE },
        { name: 'Bluegray', value: Colors.BLUEGRAY },
        { name: 'Purple', value: Colors.PURPLE },
    ];
};
